import { create } from "zustand";
import { toast } from "react-toastify";
import { getBoxes } from "../User/action.js";
import { orderABoxApi, orderABoxApiStepTwo } from "../boxOrder/action";
import useUserStore from "./useUserStore";

const useBoxOrderStore = create((set, get) => ({
    // Initial state
    userBoxes: null,
    boxLoading: false,
    box: null,
    loading: false,
    step: null,
    boxOrderError: null,

    // Synchronous actions
    goBack: () => set({ step: 1 }),
    changeOrderStep: (step) =>
        set({
            box: null,
            loading: false,
            step,
            boxOrderError: null,
        }),
    resetBox: () =>
        set({
            userBoxes: null,
            boxLoading: false,
            box: null,
            loading: false,
            step: 1,
            boxOrderError: null,
        }),

    updateBox: (newBox) => {
        const boxesList = get()?.userBoxes?.slice();
        boxesList?.shift();
        boxesList?.unshift(newBox);
        set({ userBoxes: boxesList });
    },

    // Asynchronous actions

    getUserBoxes: async () => {
        set({ boxLoading: true });
        try {
            const response = await getBoxes();
            if (response) {
                set({ userBoxes: response, boxLoading: false });
            } else {
                set({ boxLoading: false });
            }
            return response;
        } catch (error) {
            set({ boxLoading: false });
        }
    },

    orderABoxStepOne: async (payload) => {
        set({ loading: true, boxOrderError: null });
        try {
            const response = await orderABoxApi(payload);
            if (response?.customer) {
                set({ box: response, step: 2, loading: false });
            } else {
                handleApiError(response, set);
            }
        } catch (error) {
            set({ loading: false, boxOrderError: error.message });
        }
    },

    orderABoxStepTwo: async (payload) => {
        set({ loading: true, boxOrderError: null });
        try {
            const response = await orderABoxApiStepTwo(payload);
            if (response?.customer) {
                await get()?.getUserBoxes();
                set({ box: response, step: 3, loading: false });
            } else {
                handleApiError(response, set);
            }
        } catch (error) {
            set({ loading: false, boxOrderError: error.message });
        }
    },
}));

export default useBoxOrderStore;

// Helper function to handle API errors
function handleApiError(response, set) {
    if (response?.error) {
        if (response.error === "Customer has no address.") {
            toast("Oops! Your address needs a quick update.", {
                type: "error",
            });
        } else if (Array.isArray(response.error)) {
            toast(response.error[0], { type: "error" });
        }
        set({ loading: false, boxOrderError: response.error });
    }
}
